import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  routesContainer: {
    display: 'flex',
    marginBottom: '10px',
  },
  prevRoutes: {
    color: theme.palette.primary.main,
  },
  activeRoute: {
    marginLeft: '5px',
  },
}));

export default useStyles;
